import type { AddEmergencyConfigRequest } from '@/../generated-client/models';
import { AlertOptions } from '@/../generated-client/models/AlertOptions';

export function createDefaultEmergencyConfig(): AddEmergencyConfigRequest {
  return {
    org_code: '',
    spec_name: '',
    impact_detection: AlertOptions.NUMBER_0,
    fall_detection: AlertOptions.NUMBER_0,
    arc_flash_detection: AlertOptions.NUMBER_0,
    should_force_apply_this_update: false,
  };
}
